import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useHistory } from "react-router-dom";
import {BUTTON_BLUE_GRADIENT} from "../constants/colors";

export default function DashboardChoice({
  facilityId,
  url,
  icon,
  label,
  isLive,
}) {
  const history = useHistory();
  const [hovered, setHovered] = useState(false);

  const handleClick = () => {
    if (isLive === true) {
      history.push("/" + url + "/" + facilityId + "/1");
    }
  };

  // ---------- STYLES ----------
  const thisContainer = {
    display: "flex",
    alignItems: "center",
    border: hovered
      ? "1px solid rgba(255,255,255,0.25)"
      : "1px solid rgba(255,255,255,0.08)",
    margin: "10px",
    borderRadius: "14px",
    width: "240px",
    height: "60px",
    cursor: isLive ? "pointer" : "default",
    opacity: isLive ? "0.9" : "0.5",
    background: hovered
      ? BUTTON_BLUE_GRADIENT
      : "rgba(255,255,255,0.08)",
    boxShadow: hovered
      ? "0 4px 12px rgba(18,83,255,0.45)"
      : "none",
    transform: hovered ? "translateY(-1px)" : "none",
    transition: "all 0.18s ease-out",
    backdropFilter: "blur(4px)",
  };

  const iconStyle = {
    color: hovered ? "white" : "white",
    width: "34px",
    height: "34px",
    marginLeft: "18px",
  };

  const labelContainer = {
    marginLeft: "18px",
    fontSize: "16px",
    color: "white",
  };

  // ---------- RETURN ----------
  return (
    <div
      style={thisContainer}
      onClick={handleClick}
      onMouseEnter={() => isLive && setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <FontAwesomeIcon icon={icon} style={iconStyle} />
      <div style={labelContainer}>{label}</div>
    </div>
  );
}
